var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup354(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_354",
    "data-name": "Group 354",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.137,
    height: 19.137,
    viewBox: "0 0 19.137 19.137",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_227",
    "data-name": "Rectangle 227",
    width: 19.137,
    height: 19.137,
    fill: "#bfbfbf"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_353",
    "data-name": "Group 353",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_507",
    "data-name": "Path 507",
    d: "M9.568,0a9.568,9.568,0,1,0,9.568,9.568A9.578,9.578,0,0,0,9.568,0Zm0,1.248a8.32,8.32,0,1,1-8.32,8.32,8.311,8.311,0,0,1,8.32-8.32M6.032,5.616A1.456,1.456,0,1,0,7.488,7.072,1.456,1.456,0,0,0,6.032,5.616m7.072,0A1.456,1.456,0,1,0,14.56,7.072,1.456,1.456,0,0,0,13.1,5.616M4.927,11.44a.6.6,0,0,0-.494.325.631.631,0,0,0,.039.643,6.066,6.066,0,0,0,10.192,0,.645.645,0,0,0-.169-.864.653.653,0,0,0-.871.169,4.812,4.812,0,0,1-8.112,0A.718.718,0,0,0,4.927,11.44Z",
    fill: "#bfbfbf"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup354);
export default __webpack_public_path__ + "static/media/Group 354.ed2543d96093bc7b9568e65a070f4ec4.svg";
export { ForwardRef as ReactComponent };